import i18next from "i18next"
import { ErrorResponse } from "models"
import { checkFileIntegrity } from "utils"

// prettier-ignore
export const DEFAULT_ACCEPTED_EXTENSIONS = [ "jpg", "JPG", "jpeg", "JPEG", "png", "PNG", "pdf", "PDF"]
export const DEFAULT_MAX_FILE_SIZE = 10 // mo

export enum FileErrorActionType {
	READY = "READY",
	FORBIDDEN_EXTENSION = "FORBIDDEN_EXTENSION",
	OVERSIZED = "OVERSIZED",
	SECURITY_ISSUE = "SECURITY_ISSUE",
}

interface FileErrorAction {
	type: FileErrorActionType
	payload?: string
}

type GetStatesAndHelpersInputFileProps = {
	acceptedExtensions: string[]
	maxFileSize: number
}

export const getStatesAndHelpersInputFile = ({
	acceptedExtensions,
	maxFileSize,
}: GetStatesAndHelpersInputFileProps) => {
	const fileErrorReducer = (state: ErrorResponse, action: FileErrorAction) => {
		const { type, payload } = action
		switch (type) {
			case FileErrorActionType.READY: {
				return null
			}
			case FileErrorActionType.FORBIDDEN_EXTENSION: {
				return {
					code: "file-forbidden-extension",
					message: i18next.t("file_extension_error", {
						acceptedExtensions: acceptedExtensions.join(", "),
						ns: "form",
					}),
				}
			}
			case FileErrorActionType.OVERSIZED: {
				return {
					code: "file-oversized",
					message: i18next.t("file_size_error", { maxSize: maxFileSize, ns: "form" }),
				}
			}
			case FileErrorActionType.SECURITY_ISSUE: {
				return {
					code: "file-security-issue",
					message: i18next.t("file_security_issue", { ns: "form" }),
				}
			}
		}
	}

	const checkForFileError = async (file: File) => {
		// Forbidden extensions
		const fileExtension = file.name.split(".").pop()
		if (acceptedExtensions.indexOf(fileExtension) === -1) {
			return {
				type: FileErrorActionType.FORBIDDEN_EXTENSION,
				payload: acceptedExtensions.join(", "),
			}
		}
		// Oversized file
		if (file.size > maxFileSize * 1000000) {
			return {
				type: FileErrorActionType.OVERSIZED,
				payload: maxFileSize.toString(),
			}
		}
		// Unsecure file
		const isFileSecure = await checkFileIntegrity(file)
		if (!isFileSecure) {
			return {
				type: FileErrorActionType.SECURITY_ISSUE,
			}
		}

		return null
	}

	return {
		fileErrorReducer,
		checkForFileError,
	}
}
